var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBilling(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.24967 13.3333L13.7497 7.83333L8.24967 13.3333ZM8.70801 8.29167H8.71717H8.70801ZM13.2913 12.875H13.3005H13.2913ZM17.4163 19.75V5.08333C17.4163 4.5971 17.2232 4.13079 16.8794 3.78697C16.5356 3.44315 16.0692 3.25 15.583 3.25H6.41634C5.93011 3.25 5.4638 3.44315 5.11998 3.78697C4.77616 4.13079 4.58301 4.5971 4.58301 5.08333V19.75L7.79134 17.9167L10.9997 19.75L14.208 17.9167L17.4163 19.75ZM9.16634 8.29167C9.16634 8.41322 9.11805 8.5298 9.0321 8.61576C8.94614 8.70171 8.82956 8.75 8.70801 8.75C8.58645 8.75 8.46987 8.70171 8.38392 8.61576C8.29796 8.5298 8.24967 8.41322 8.24967 8.29167C8.24967 8.17011 8.29796 8.05353 8.38392 7.96758C8.46987 7.88162 8.58645 7.83333 8.70801 7.83333C8.82956 7.83333 8.94614 7.88162 9.0321 7.96758C9.11805 8.05353 9.16634 8.17011 9.16634 8.29167ZM13.7497 12.875C13.7497 12.9966 13.7014 13.1131 13.6154 13.1991C13.5295 13.285 13.4129 13.3333 13.2913 13.3333C13.1698 13.3333 13.0532 13.285 12.9672 13.1991C12.8813 13.1131 12.833 12.9966 12.833 12.875C12.833 12.7534 12.8813 12.6369 12.9672 12.5509C13.0532 12.465 13.1698 12.4167 13.2913 12.4167C13.4129 12.4167 13.5295 12.465 13.6154 12.5509C13.7014 12.6369 13.7497 12.7534 13.7497 12.875Z",
    stroke: "#718096",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBilling);
export default __webpack_public_path__ + "static/media/Billing.70395e06472246e0ab4cec11293e25da.svg";
export { ForwardRef as ReactComponent };